module.exports = __webpack_public_path__ + "img/c13-min.2fc0f399.png";